<template>
    <main
        :data-app-swingu="true"
        :data-browser="true"
        data-theme="default"
        class="flex min-h-screen flex-col items-center bg-white text-gray-800 antialiased"
    >
        <ImpersonationBanner />
        <header class="h-[86px] w-full bg-gray-900">
            <Nav
                :player-name="auth.user.username"
                class="hidden [@media(min-width:992px)]:flex"
            />
            <MobileNav class="flex [@media(min-width:992px)]:hidden" />
        </header>
        <article class="w-full">
            <slot />
        </article>
        <SwingUFooter class="mt-xl w-full" />
    </main>
</template>

<script setup>
import Nav from "@components/app-swingu/header-nav.vue";
import MobileNav from "@components/app-swingu/mobile-header-nav.vue";
import SwingUFooter from "@global/layout/swingu-com/layout-footer.vue";
import ImpersonationBanner from "@global/ui/impersonation-banner.vue";
</script>

<script>
export default {
    props: {
        auth: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss">
/**
    There is an overflow-y-scroll in resources/views/swingu/app.blade.php that overrides any scoll-locked style applied via vue final modal.
    Using logic from app.swingu, toggle a modal-active class when modal is opened/closed in order to lock the screen behind it.

    Style needs to be applied here in order to reach the scope of the first html parent element.
 */
.modal-active {
    height: 100%;
    overflow: hidden;
}
</style>
